import { createContext, ReactNode, useContext } from 'react';
import { BuilderCapabilities, RESTRICTED_CAPABILITIES } from './builder-capabilities';

const BuilderCapabilitiesContext = createContext<BuilderCapabilities | null>(null);

/**
 * Da montare una volta per flusso, in cima all'albero del builder: ItineraryBuilder per
 * /itinerary-builder, SharedProposalView per il link condiviso. Il valore va calcolato
 * con resolveBuilderCapabilities, non a mano.
 */
export const BuilderCapabilitiesProvider = ({
  value,
  children,
}: {
  value: BuilderCapabilities;
  children: ReactNode;
}) => (
  <BuilderCapabilitiesContext.Provider value={value}>{children}</BuilderCapabilitiesContext.Provider>
);

/**
 * Le capacita' del flusso corrente. Fuori da un provider ritorna quelle piu'
 * restrittive (sola lettura, vista cliente): dimenticare il provider non deve mai
 * aprire la modifica o mostrare costi al cliente.
 */
export const useBuilderCapabilities = (): BuilderCapabilities => {
  const value = useContext(BuilderCapabilitiesContext);
  if (!value) {
    if (import.meta.env.DEV) {
      console.warn('[useBuilderCapabilities] nessun BuilderCapabilitiesProvider: uso le capacita\' restrittive');
    }
    return RESTRICTED_CAPABILITIES;
  }
  return value;
};
